import {Component, effect, OnInit} from '@angular/core';
import {CustomMessageService} from "library";
import {SalesWorkflowService} from "projects/store/src/app/services/api/v1/sales-workflow.service";
import {ActivatedRoute, Router, NavigationEnd} from "@angular/router";
import {ErrorTemplate} from "projects/store/src/app/interfaces";
import { SalesWorkflow } from '../../../enums';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-error-message',
  templateUrl: './error-message.component.html'
})
export class ErrorMessageComponent implements OnInit {
  visible = false;
  flowCode: string = '';
  error!: ErrorTemplate;
  isV3Theme: boolean = false;

  constructor(public customMessageService: CustomMessageService,
              private salesWorkflowService: SalesWorkflowService,
              private route: ActivatedRoute,
              private router: Router) {
    // Escuchar cambios de navegación para actualizar el flow_code
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateFlowCode();
    });

    effect(() => {
      if(Object.keys(this.customMessageService.unexpectedErrorDialog()).length !== 0) {
        // Obtener el flow_code justo cuando se muestra el error
        this.updateFlowCode();
        this.visible = true;
        this.error = this.customMessageService.unexpectedErrorDialog();
      }
    });
  }

  ngOnInit() {
    // Actualizar flow_code inicial
    this.updateFlowCode();
  }

  /**
   * Obtiene el flow_code desde la ruta hija activa
   */
  private updateFlowCode(): void {
    let route = this.router.routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
      if (route.snapshot.params['flow_code']) {
        this.flowCode = route.snapshot.params['flow_code'];
        return;
      }
    }

    this.flowCode = '';
  }

  goToHome() {
    this.visible = false;
    this.salesWorkflowService.navigateToInitial(this.flowCode);
  }

  getIconPosition(): 'left' | 'right' {
    return (this.error.button?.iconPos as 'left' | 'right') || 'left';
  }

  protected get isFlowKrdya(): boolean {
    return this.flowCode === SalesWorkflow['app-krdya-cliente'] || this.flowCode === SalesWorkflow['app-krdya-kredicash'];
  }

  protected readonly location = location;
}
